import React, { useState } from "react";
import { useAppContext } from "../../AppProvider";
import { useResetPasswordUserContext } from "./providers/ResetPassword.tsx";
import { useIndexUsersContext } from "./providers/Index.tsx";
import ButtonUtility from "../../Components/Buttons/Utility.tsx";
import ButtonConfirm from "../../Components/Buttons/Confirm.tsx";
import { getFieldError } from "../../utilities/utilities.ts";
import { ResetPasswordUser } from "../../Models/User.ts";
import {
  faEye,
  faEyeSlash,
  faLoader,
} from "../../utilities/fontawesomeIcons.js";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ResetPassword = () => {
  const { data, loader, error, callback, edit } = useResetPasswordUserContext();
  const indexUsersContext = useIndexUsersContext();
  const { dictionary } = useAppContext();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (
    name: string,
    value: string | boolean | number | object | null,
    key: string
  ) => {
    edit(
      {
        ...data,
        [name]: value,
      } as ResetPasswordUser,
      key as keyof ResetPasswordUser,
      false
    );
  };

  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <h3 className="text-center">
            {indexUsersContext?.modalConfig?.title}
          </h3>
          <div
            className="d-grid grid-column mb-2"
            style={{
              gridTemplateColumns: `1fr 1fr`,
            }}
          >
            <div>
              <label className="label-2">{dictionary.users.password}</label>
              <InputBoxIcon
                name="password"
                value={data?.password || ""}
                type={showPassword ? "text" : "password"}
                onChange={({ target }) => {
                  handleChange(target.name, target.value, "password");
                }}
                onClickIcon={() => {
                  setShowPassword(!showPassword);
                }}
                classNameIcon="cursor-pointer"
                icon={showPassword ? faEyeSlash : faEye}
                error={getFieldError(error, "password")}
              />
            </div>
            <div>
              <label className="label-2">
                {dictionary.users.confirm_password}
              </label>
              <InputBoxIcon
                name="confirmPassword"
                value={data?.confirmPassword || ""}
                type={showConfirmPassword ? "text" : "password"}
                onChange={({ target }) => {
                  handleChange(target.name, target.value, "confirmPassword");
                }}
                onClickIcon={() => {
                  setShowConfirmPassword(!showConfirmPassword);
                }}
                icon={showConfirmPassword ? faEyeSlash : faEye}
                classNameIcon="cursor-pointer"
                error={getFieldError(error, "confirmPassword")}
              />
            </div>
          </div>
        </React.Fragment>
      )}

      <div className="d-flex mt-3">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonConfirm
          className="w-50"
          onClick={() => edit(data, null, true)}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.resetPassword}
        </ButtonConfirm>
      </div>
    </React.Fragment>
  );
};
export default ResetPassword;
